const OptionButton = ({
  name, onClick, disabled, options = {}
}) => {
  const OptionComponent = options.type === 'link' ? 'a' : 'button'
  const optionComponentProps = options.type === 'link' ? { target: '_blank', href: options.url } : { onClick: disabled ? () => null : onClick }
  const classesNames = 'rounded-full inline-block text-center w-full bg-red-350 p-4 md:py-3 font-button font-medium text-sm md:text-xs leading-none text-white'

  return (
    <OptionComponent className={classesNames} {...optionComponentProps}>
      {name}
    </OptionComponent>
  )
}

export default OptionButton
